import { Charts } from './Charts';
import HomelessChartsDataProvider from './contexts/HomelessChartsDataContext';

const HomelessWrapper = () => {
    return (
        <HomelessChartsDataProvider>
            <Charts />
        </HomelessChartsDataProvider>
    );
};

export default HomelessWrapper;
